import React, {
	useEffect
}from "react"
import {
	 Select, Modal, Form, DatePicker
}from "antd"
import moment from "moment"
import 'antd/lib/date-picker/style/index.css'
import {
	useSelector
}from 'react-redux'
import CustomButton from "../../../components/ButtonCustom"
import {
	CustomSelect
}from "../../../components/CustomSelect"
import {
	CustomInput
}from "../../../components/CustomInput"
import i18n from "../localization"
import Notifications from "../../../helpers/Notifications"

const ReSubthemeOgulChangeForm = (props) => {
	const isRu = useSelector(state => state.globalReducer.isRu)
	const { visible, setVisible, setResource, resource, themes, create, update } = props
	const [form] = Form.useForm()
	const dateFormat = 'DD.MM.YYYY'
	const { Option } = Select
	const { isSending, subThemesOgulChanged } = useSelector((state) => state.reSubthemesOgulReducer)

	useEffect(() => {
		if (resource){
			form.setFieldsValue({
				reTheme   : resource.themeOgulId,
				code      : resource.code,
				name      : resource.name,
				nameBel   : resource.nameBel,
				startDate : moment(resource.startDate, dateFormat)
			})
		}
	}, [resource])

	function handleCancel(){
		form.resetFields()
		setVisible(false)
		setResource(null)
	}
	useEffect(() => {
		if (subThemesOgulChanged)
			handleCancel()
	}, [subThemesOgulChanged])

	const onFinish = values => {
		  const updateValues = {
		  	id          : resource?.id,
		  	code        : values.code,
		  	name        : values.name,
		  	nameBel     : values.nameBel,
		  	startDate   : values.startDate.format("YYYY-MM-DD"),
			themeOgulId : values.reTheme
		  }
		 const previousValues = {
		  	id          : resource?.id,
		  	code        : resource?.code,
		  	name        : resource?.name,
		  	nameBel     : resource?.nameBel,
		  	startDate   : resource?.startDate ? moment(resource.startDate, dateFormat).format("YYYY-MM-DD") : null,
			themeOgulId : resource?.themeOgulId
		  }
		  if (JSON.stringify(updateValues) === JSON.stringify(previousValues))
		  	Notifications.errorNotice(i18n.messageDataNotChanged[isRu], null, 20)
		  else
		  	resource ? update(updateValues) : create(updateValues)
	}

	return (
		<div>
			<Modal
				destroyOnClose
				footer={ null }
				title={ resource ? i18n.titleModalEditItem[isRu] : i18n.titleModalAddItem[isRu] }
				visible={ visible }
				width={ 900 }
				onCancel={ handleCancel }
			>
				<Form
					form={ form }
					labelAlign="left"
					labelCol={ { span: 6 } }
					name="nsi-form"
					wrapperCol={ { span   : 16,
						offset : 1 } }
					onFinish={ onFinish }
				>
					<Form.Item
						label={ i18n.tableHeaderCode[isRu] }
						name="code"
						rules={ [
							{ required : true,
								message  : i18n.messageCodeValidate[isRu],
								pattern  : /^\d{1,4}$/ }
						] }
					>
						<CustomInput
							disabled={ Boolean(resource) }
							placeholder={ i18n.tableHeaderCode[isRu] }
						/>
					</Form.Item>
					<Form.Item
						label={ i18n.tableHeaderNameRu[isRu] }
						name="name"
						rules={ [
							{ required : true,
								min      : 4,
								max      : 200,
								message  : i18n.messageNameRuValidate[isRu] }
						] }
					>
						<CustomInput placeholder={ i18n.tableHeaderNameRu[isRu] } />
					</Form.Item>
					<Form.Item
						label={ i18n.tableHeaderNameBel[isRu] }
						name="nameBel"
						rules={ [
							{ required : true,
								min      : 4,
								max      : 200,
								message  : i18n.messageNameBelValidate[isRu] }
						] }
					>
						<CustomInput placeholder={ i18n.tableHeaderNameBel[isRu] } />
					</Form.Item>
					<Form.Item
						label={ i18n.themeOgul[isRu] }
						name="reTheme"
						rules={ [
							{ required : true,
								message  : i18n.themeOgulLabel[isRu] }
						] }
					>
						<CustomSelect
							showSearch
							filterOption={ (input, option) => option.children
								  .toLowerCase()
								  .indexOf(input.toLowerCase()) >= 0 }
							placeholder={ i18n.themeOgulLabel[isRu] }
							style={ {
								width: '100%'
							} }
						>
							{

								themes.map((value, index) => {
									return (
										<Option
											 key={ value.id }
											style={ {
												width: '100%'
											} }
											title={ isRu || !value.nameBel ? value.name : value.nameBel }
											value={ value.id.toString() }
										>
											{ isRu || !value.nameBel ? value.name : value.nameBel }
										</Option>
									)
								})
							}
						</CustomSelect>
					</Form.Item>
					<Form.Item
						label={ i18n.tableHeaderDateStart[isRu] }
						name="startDate"
						rules={ [
							{
								required : true,
								message  : i18n.messageDateStartValidate[isRu]
							}
						] }
					>
						<DatePicker
							format="DD.MM.YYYY"
							placeholder={ i18n.tableHeaderDateStart[isRu] }
							style={ { width: "100%" } }
						/>
					</Form.Item>
					<Form.Item wrapperCol={ { span: 24 } }>
						<CustomButton
							htmlType="submit"
							loading={ isSending }
							type="orange"
						>
							{ i18n.buttonSave[isRu] }
						</CustomButton>
					</Form.Item>
				</Form>
			</Modal>
		</div>
	)
}
export default ReSubthemeOgulChangeForm
